import {
  AccessorForAdministartionTablesEnum,
  AccessorForTablesEnum,
  TitleForColumnsAdministrationTableEnum,
  TitleForColumnsTableEnum,
} from './enum';

export const NumberLinesItems = [
  { label: 50, id: 50 },
  { label: 100, id: 100 },
  { label: 250, id: 250 },
  { label: 500, id: 500 },
];

export const dataModel = [
  {
    id: '1',
    title: 'Модель №1',
    version: 5,
    text: 'Использование «рыбы» на протяжении нескольких веков считалось нормой и переросло в некий стандарт, несмотря на радикально меняющиеся сферы ее пр Использование «рыбы» на протяжении нескольких веков считалось нормой и переросло в некий стандарт, несмотря на радикально меняющиеся сферы ее пр...Использование «рыбы» на протяжении нескольких веков считалось нормой и переросло в некий стандарт, несмотря на радикально меняющиеся сферы ее некий стандарт, несмотря на радикально меняющиеся',
    dateChange: '10.02.2022',
    dateLast: '28.02.2022',
  },
  {
    id: '2',
    title: 'Модель №2',
    version: 4,
    text: 'Использование «рыбы» на протяжении нескольких веков считалось нормой и переросло в некий стандарт, несмотря на радикально меняющиеся сферы ее пр Использование «рыбы» на протяжении нескольких веков считалось нормой и переросло в некий стандарт, несмотря на радикально меняющиеся сферы ее пр...Использование «рыбы» на протяжении нескольких веков считалось нормой и переросло в некий стандарт',
    dateChange: '10.02.2022',
    dateLast: '28.02.2022',
  },
  {
    id: '3',
    title: 'Модель №3',
    version: 3,
    text: 'Использование «рыбы» на протяжении нескольких веков считалось нормой и переросло в некий стандарт, несмотря на радикально меняющиеся сферы ее пр Использование «рыбы» на протяжении нескольких веков считалось нормой и переросло в некий стандарт, несмотря на радикально меняющиеся сферы ее пр...Использование «рыбы» на протяжении нескольких веков считалось нормой и переросло в некий стандарт',
    dateChange: '10.02.2022',
    dateLast: '28.02.2022',
  },
  {
    id: '4',
    title: 'Модель №1',
    version: 4,
    text: 'Использование «рыбы» на протяжении нескольких веков считалось нормой и переросло в некий стандарт, несмотря на радикально меняющиеся сферы ее пр Использование «рыбы» на протяжении нескольких веков считалось нормой и переросло в некий стандарт, несмотря на радикально меняющиеся сферы ее пр...Использование «рыбы» на протяжении нескольких веков считалось нормой и переросло в некий стандарт',
    dateChange: '10.02.2022',
    dateLast: '28.02.2022',
  },
  {
    id: '5',
    title: 'Модель №1',
    version: 5,
    text: 'Использование «рыбы» на протяжении нескольких веков считалось нормой и переросло в некий стандарт, несмотря на радикально меняющиеся сферы ее пр Использование «рыбы» на протяжении нескольких веков считалось нормой и переросло в некий стандарт, несмотря на радикально меняющиеся сферы ее пр...Использование «рыбы» на протяжении нескольких веков считалось нормой и переросло в некий стандарт',
    dateChange: '10.02.2022',
    dateLast: '28.02.2022',
  },
  {
    id: '6',
    title: 'Модель №1',
    version: 5,
    text: 'Использование «рыбы» на протяжении нескольких веков считалось нормой и переросло в некий стандарт, несмотря на радикально меняющиеся сферы ее пр Использование «рыбы» на протяжении нескольких веков считалось нормой и переросло в некий стандарт, несмотря на радикально меняющиеся сферы ее пр...Использование «рыбы» на протяжении нескольких веков считалось нормой и переросло в некий стандарт',
    dateChange: '10.02.2022',
    dateLast: '28.02.2022',
  },
  {
    id: '7',
    title: 'Модель №1',
    version: 5,
    text: 'Использование «рыбы» на протяжении нескольких веков считалось нормой и переросло в некий стандарт, несмотря на радикально меняющиеся сферы ее пр Использование «рыбы» на протяжении нескольких веков считалось нормой и переросло в некий стандарт, несмотря на радикально меняющиеся сферы ее пр...Использование «рыбы» на протяжении нескольких веков считалось нормой и переросло в некий стандарт',
    dateChange: '10.02.2022',
    dateLast: '28.02.2022',
  },
];

export const realmIdKeycloak = process.env.KEYCLOAK_REALM;
export const clientIdKeycloak = process.env.KEYCLOAK_CLIEND_ID;

export const tabsEditModal = [
  {
    id: 'model',
    label: 'Модели',
  },
  {
    id: 'user',
    label: 'Пользователи',
  },
];

export const allRole = {
  key: 'allRole',
  name: 'Все роли',
};

export const userModal = [
  {
    id: '1',
    username: 'username_0001',
    role_name: 'force_logic_admin',
  },
  {
    id: '2',
    username: 'username_0002',
    role_name: 'force_logic_admin',
  },
  {
    id: '3',
    username: 'username_0003',
    role_name: 'force_logic_admin',
  },
  {
    id: '4',
    username: 'username_0004',
    role_name: 'force_logic_admin',
  },
  {
    id: '5',
    username: 'username_0005',
    role_name: 'force_logic_admin',
  },
  {
    id: '6',
    username: 'username_0006',
    role_name: 'force_logic_admin',
  },
];

export const allUSer = [
  {
    id: '7',
    username: 'username_0007',
    role_name: 'force_logic_admin',
  },
  {
    id: '8',
    username: 'username_0008',
    role_name: 'force_logic_moderator',
  },
  {
    id: '9',
    username: 'username_0009',
    role_name: 'force_logic_user',
  },
  {
    id: '10',
    username: 'username_00010',
    role_name: 'force_logic_admin',
  },
];

export const debounceTimeModel = 800;

export const filterSearchLetters = 2;

export const intervalUpdateToken = process.env.KEYCLOAK_INTERVAL_UPDATE_TOKEN;

export const updateTokenSecondBefore = process.env.KEYCLOAK_UPDATE_TOKEN_SECOND_BEFORE;

export const randomValue = 'f';

export const heightTextCard = {
  dekstop: 42,
  mobile: 63,
};

export const heightTextViewModel = {
  dekstop: 21,
  mobile: 42,
};

export const defaultRunningProperties = [
  '{MAX_MEMORY_MB}',
  '{RANDOM_SEED}',
  '{START_DATE}',
  '{START_TIME}',
  '{STOP_DATE}',
  '{STOP_MODE}',
  '{STOP_TIME}',
];

export const testOutput = [
  {
    name: 'скорость',
    value: 30,
  },
  {
    name: 'скорость',
    value: 30,
  },
  {
    name: 'скорость',
    value: 30,
  },
  {
    name: 'скорость',
    value: 30,
  },
  {
    name: 'скорость',
    value: 30,
  },
  {
    name: 'скорость',
    value: 30,
  },
  {
    name: 'высота',
    value: 150,
  },
  {
    name: 'высота',
    value: 150,
  },
  {
    name: 'высота',
    value: 150,
  },
  {
    name: 'высота',
    value: 150,
  },
  {
    name: 'высота',
    value: 150,
  },
  {
    name: 'высота',
    value: 150,
  },
  {
    name: 'высота',
    value: 150,
  },
  {
    name: 'приближение',
    value: 34,
  },
  {
    name: 'высота',
    value: 150,
  },
  {
    name: 'высота',
    value: 150,
  },
  {
    name: 'приближение',
    value: 34,
  },
  {
    name: 'высота',
    value: 150,
  },
  {
    name: 'высота',
    value: 150,
  },
  {
    name: 'приближение',
    value: 34,
  },
  {
    name: 'высота',
    value: 150,
  },
  {
    name: 'высота',
    value: 150,
  },
  {
    name: 'приближение',
    value: 34,
  },
  {
    name: 'высота',
    value: 150,
  },
  {
    name: 'высота',
    value: 150,
  },
  {
    name: 'приближение',
    value: 34,
  },
  {
    name: 'высота',
    value: 150,
  },
  {
    name: 'высота',
    value: 150,
  },
  {
    name: 'приближение',
    value: 34,
  },
  {
    name: 'высота',
    value: 150,
  },
  {
    name: 'высота',
    value: 150,
  },
  {
    name: 'приближение',
    value: 34,
  },
  {
    name: 'высота',
    value: 150,
  },
  {
    name: 'высота',
    value: 150,
  },
  {
    name: 'приближение',
    value: 34,
  },
  {
    name: 'приближение',
    value: 34,
  },
  {
    name: 'высота',
    value: 150,
  },
  {
    name: 'высота',
    value: 150,
  },
  {
    name: 'приближение',
    value: 34,
  },
  {
    name: 'высота',
    value: 150,
  },
  {
    name: 'высота',
    value: 150,
  },
  {
    name: 'приближение',
    value: 34,
  },
  {
    name: 'приближение',
    value: 34,
  },
  {
    name: 'высота',
    value: 150,
  },
  {
    name: 'высота',
    value: 150,
  },
  {
    name: 'приближение',
    value: 34,
  },
  {
    name: 'высота',
    value: 150,
  },
  {
    name: 'высота',
    value: 150,
  },
  {
    name: 'приближение',
    value: 34,
  },
  {
    name: 'приближение',
    value: 34,
  },
  {
    name: 'высота',
    value: 150,
  },
  {
    name: 'высота',
    value: 150,
  },
  {
    name: 'приближение',
    value: 34,
  },
  {
    name: 'высота',
    value: 150,
  },
  {
    name: 'высота',
    value: 150,
  },
  {
    name: 'приближение',
    value: 34,
  },
];

export const ColumnsJournalTable = [
  {
    title: TitleForColumnsTableEnum.Ip,
    accessor: AccessorForTablesEnum.Ip,
    width: 108,
  },
  {
    title: TitleForColumnsTableEnum.DateTime,
    accessor: AccessorForTablesEnum.DateEvent,
    width: 124,
  },
  {
    title: TitleForColumnsTableEnum.Login,
    accessor: AccessorForTablesEnum.Login,
    width: 140,
  },
  {
    title: TitleForColumnsTableEnum.Role,
    accessor: AccessorForTablesEnum.Role,
  },
  {
    title: TitleForColumnsTableEnum.Event,
    accessor: AccessorForTablesEnum.Event,
    width: 498,
  },
  {
    title: TitleForColumnsTableEnum.Service,
    accessor: AccessorForTablesEnum.Service,
    width: 498,
  },
];

export const columnsAdministrationTable = [
  {
    title: TitleForColumnsAdministrationTableEnum.Fio,
    accessor: AccessorForAdministartionTablesEnum.Fio,
    width: 108,
  },
  {
    title: TitleForColumnsAdministrationTableEnum.Username,
    accessor: AccessorForAdministartionTablesEnum.Username,
    width: 124,
  },
  {
    title: TitleForColumnsAdministrationTableEnum.RoleName,
    accessor: AccessorForAdministartionTablesEnum.RoleName,
    width: 140,
  },
  {
    title: TitleForColumnsAdministrationTableEnum.NumberAvailableModels,
    accessor: AccessorForAdministartionTablesEnum.NumberAvailableModels,
  },
];

export const RowsJournalTable = [
  {
    id: '1',
    ip: '46.146.131.96',
    dateEvent: '02.06.2022 16:52',
    login: 'mail@email.org',
    name: 'Иванов Петр Александрович',
    role: 'Администратор',
    event: 'Добавил сотрудника Сергеев Анатолий Алексеевич',
  },
  {
    id: '2',
    ip: '46.148.131.96',
    dateEvent: '08.04.2022 16:52',
    login: 'emailnew@mail.org',
    name: 'Петров Александр Иванович',
    role: 'Модератор подразделения',
    event: 'Изменил статус Одобрен для Сертификат о вакцинации 2021',
  },
  {
    id: '3',
    ip: '46.132.131.96',
    dateEvent: '06.10.2022 16:52',
    login: 'emailold@mail.org',
    name: 'Александров Иван Петрович',
    role: 'Медицинский работник',
    event:
      'Изменил статус Согласовано для Одобрение бюро пропусков, длинное название dfgdfgg fg fghf fghfghfghfgh fghfghfghfgh fghfghfg',
  },
];

export enum tabsJournalSidebarEnum {
  insert = 'insert',
  update = 'update',
  status = 'status',
}

export const tabsJournalSidebar = [
  {
    name: 'Добавление',
    id: tabsJournalSidebarEnum.insert,
  },
  {
    name: 'Обновление',
    id: tabsJournalSidebarEnum.update,
  },
  {
    name: 'Статус загрузки',
    id: tabsJournalSidebarEnum,
  },
];

export const formatIsoFns = "yyyy-MM-dd'T'HH:mm:ss.SSSSSS";
